import type { CategoryID } from "@/ts/types/category-id-types";
import type { SiteID } from "@/ts/types/site-types";

type FooterSiteLink = {
    viewId: CategoryID,
    textAsLink?: string,
};
type FooterSiteSection = {
    type: 'links' | 'social-media',
    links?: FooterSiteLink[],
    mobile?: boolean,
};
type FooterSiteLinksSetup = Partial<Record<SiteID, FooterSiteSection[]>>;

export default {
    FUND_MX: [
        {
            type: 'links',
            links: [
                {
                    viewId: 'promos',
                    textAsLink: 'PromosAndTourns',
                },
                {
                    viewId: 'fun-club',
                },
                {
                    viewId: 'contact-us',
                },
                {
                    viewId: 'methods-page',
                },
                {
                    viewId: 'faq',
                },
            ],
        },
        {
            type: 'social-media',
            mobile: true,
        },
        {
            type: 'links',
            links: [
                {
                    viewId: 'terms-and-conditions'
                },
                {
                    viewId: 'promo-terms'
                },
                {
                    viewId: 'privacy-policy'
                },
                {
                    viewId: 'cookies-policy'
                },
                {
                    viewId: 'responsible-gaming'
                },
                {
                    viewId: 'sport-betting-terms-cond'
                },
            ],
        },
        {
            type: 'social-media',
            mobile: false,
        },
    ],
    SKY_IO: [
        {
            type: 'links',
            links: [
                {
                    viewId: 'contact-us',
                },
                {
                    viewId: 'responsible-gaming',
                },
            ],
        },
        {
            type: 'links',
            links: [
                {
                    viewId: 'terms-and-conditions',
                },
                {
                    viewId: 'promo-terms',
                },
            ],
        },
        {
            type: 'links',
            links: [
                {
                    viewId: 'kyc-policy',
                },
                {
                    viewId: 'aml-policy',
                },
            ],
        },
        {
            type: 'links',
            links: [
                {
                    viewId: 'privacy-policy',
                },
                {
                    viewId: 'sport-betting-terms-cond',
                },
            ],
        },
    ],
} as FooterSiteLinksSetup;